// eslint-disable-next-line no-restricted-imports
import useCopyToClipboardBase from 'react-use/lib/useCopyToClipboard';

export default useCopyToClipboardBase;
